import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/Functions/ScrollToTop";
import "./App.css";
import "./index.css";

import Navigation from "./components/Navigation/Navigation";
import Footer from "./components/Footer/Footer";
import FeedbackForm from "./components/Footer/FeedbackForm.js";

// HOME PAGE Imports
import HomePage from "./components/Pages/1-Home-Page/0-Home-Page-Main/HomePage";

// ABOUT US PAGE Imports
import WhoWeAre from "./components/Pages/2-AboutUs-Page/1-WhoWeAre/0-WhoWeAre-Main/WhoWeAre";
import FullGallery from "./components/Pages/2-AboutUs-Page/1-WhoWeAre/5-Gallery/FullGallery";
import WhatWeveDone from "./components/Pages/2-AboutUs-Page/2-WhatWeveDone/WhatWeveDone";
import ScreeningsGallery from "./components/Pages/2-AboutUs-Page/2-WhatWeveDone/ScreeningsGallery";
import VolleyballGallery from "./components/Pages/2-AboutUs-Page/2-WhatWeveDone/VolleballGallery";
import Testimonials from "./components/Pages/2-AboutUs-Page/3-Testimonials/Testimonials";
import Board from "./components/Pages/2-AboutUs-Page/4-Board/Board";

// EDUCATION OF HEART PAGE Imports
import HeartFactPage from "./components/Pages/3-Education of the Heart/1-Heart Facts/0-HeartFacts-Main/HeartFactPage";
import ScreenHome from "./components/Pages/3-Education of the Heart/2-Screenings/0-Screening-Home/ScreenHome";
import Emergency from "./components/Pages/3-Education of the Heart/3-Emergencies/0-Emergency-Main/Emergency";
import TipsHome from "./components/Pages/3-Education of the Heart/4-Expert Health Tips/0-Tips-Main/TipsHome";

// GIFT OF ART PAGE Imports
import Scholarship from "./components/Pages/4-GiftOfArt-Page/1-Scholarship/Scholarship/Scholarship";
import Winners from "./components/Pages/4-GiftOfArt-Page/1-Scholarship/Winners/Winners.js";
import Guide from "./components/Pages/4-GiftOfArt-Page/1-Scholarship/ScholarshipGuide/Guide.js";
import Plays from "./components/Pages/4-GiftOfArt-Page/2-Plays/Plays";
import Films from "./components/Pages/4-GiftOfArt-Page/3-Films/Films";
import Books from "./components/Pages/4-GiftOfArt-Page/4-Books/Books";
import UpcomingEvents from "./components/Pages/4-GiftOfArt-Page/5-UpcomingEvents/UpcomingEvents";
import SafeDr from "./components/Pages/4-GiftOfArt-Page/5-UpcomingEvents/SafeDriver/SafeDr.js";
import StoriesOfHeart from "./components/Pages/4-GiftOfArt-Page/6-StoriesOfHeart/StoriesOfHeart";

import Support from "./components/Pages/1-Home-Page/7-Support/Support";

// PEOPLE WE LOVE Imports
import Tributes from "./components/Pages/5-PeopleWeLove/1-Tributes/0-Tribute-Main/Tributes";
import Survivors from "./components/Pages/5-PeopleWeLove/2-Survivors/0-Survivors-Main/Survivor";

// RESOURCES PAGE Imports
import ScaAndTrainingResources from "./components/Pages/6-Resources-Page/1-SCAAndTrainingResources/SCAAndTrainingResources";
import HospitalScreeningResources from "./components/Pages/6-Resources-Page/2-HospitalScreeningResources/HospitalScreeningResources";

// DonatePage Imports
import DonateMain from "./components/Pages/7-DonatePage/0-DonateMain/DonateMain.js";
import DonateSuccess from "./components/Pages/7-DonatePage/1-DonateSection/DonateSuccess.js";
import DonateCancel from "./components/Pages/7-DonatePage/1-DonateSection/DonateCancel.js";

function App() {
  const [showFeedback, setShowFeedback] = useState(false);

  // Automatically show feedback form after 5 minutes 
 useEffect(() => {
  const hasShownFeedback = sessionStorage.getItem("feedbackShown");

  if (!hasShownFeedback) {
    const timer = setTimeout(() => {
      setShowFeedback(true);
      sessionStorage.setItem("feedbackShown", "true"); 
    }, 300000); // 5 minutes

    return () => clearTimeout(timer);
  }
}, []);


  return (
    <Router>
      <ScrollToTop />{" "}
      {/* This component ensures every navigation scrolls to the top */}
      <div className="App">
        <Navigation />

        {/* Feedback form automatically appears after 5 minutes */}
        {showFeedback && (
          <FeedbackForm onClose={() => setShowFeedback(false)} />
        )}

        <Routes>
          {/* HOME PAGE */}
          <Route path="/" element={<HomePage />} />

          {/* ABOUT US PAGE */}
          <Route path="/about/who-we-are" element={<WhoWeAre />} />
          <Route path="/full-gallery" element={<FullGallery />} />
          <Route path="/about/what-weve-done" element={<WhatWeveDone />} />
          <Route path="/screenings-gallery" element={<ScreeningsGallery />} />
          <Route path="/volleyball-gallery" element={<VolleyballGallery />} />
          <Route path="/about/testimonials" element={<Testimonials />} />
          <Route path="/about/board" element={<Board />} />

          {/* EDUCATION OF THE HEART */}
          <Route
            path="/education-of-the-heart/heart-fact-page"
            element={<HeartFactPage />}
          />
          <Route
            path="/education-of-the-heart/screening-home"
            element={<ScreenHome />}
          />
          <Route
            path="/education-of-the-heart/emergency-main"
            element={<Emergency />}
          />
          <Route
            path="/education-of-the-heart/tips-main"
            element={<TipsHome />}
          />

          {/* GIFT OF ART PAGE */}
          <Route path="/gift-of-art/scholarship" element={<Scholarship />} />
          <Route
            path="/gift-of-art/scholarship/winners"
            element={<Winners />}
          />
          <Route
            path="/gift-of-art/scholarship/guidelines"
            element={<Guide />}
          />
          <Route path="/gift-of-art/plays" element={<Plays />} />
          <Route path="/gift-of-art/films" element={<Films />} />
          <Route path="/gift-of-art/books" element={<Books />} />
          <Route
            path="/gift-of-art/upcoming-events"
            element={<UpcomingEvents />}
          />
          <Route
            path="/gift-of-art/upcoming-events/safe-driver-campaign"
            element={<SafeDr />}
          />
          <Route
            path="/gift-of-art/heart-stories"
            element={<StoriesOfHeart />}
          />

          <Route path="/support" element={<Support />} />

          {/* PEOPLE WE LOVE */}
          <Route path="/people-we-love/tributes" element={<Tributes />} />
          <Route path="/people-we-love/survivors" element={<Survivors />} />

          {/* RESOURCES PAGE */}
          <Route
            path="/resources/sca-and-training-resources"
            element={<ScaAndTrainingResources />}
          />
          <Route
            path="/resources/hospital-screening-resources"
            element={<HospitalScreeningResources />}
          />

          {/* DONATE PAGE */}
          <Route path="/donate-main" element={<DonateMain />} />
          <Route path="/success" element={<DonateSuccess />} />
          <Route path="/donate/cancel" element={<DonateCancel />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
